/**
 * Trivia category slugs — variant-agnostic.
 *
 * The bank (questions) is keyed by these slugs. Variant-specific category
 * metadata (titles, motifs, colors, backgrounds) lives under each variant
 * (e.g. `variants/reading-room/categories.ts`). The engine and bank only
 * need the slug type.
 */
export type TriviaCategorySlug =
  | 'music-60s'
  | 'music-70s'
  | 'geography'
  | 'classic-films'
  | 'tv-classics'
  | 'around-the-house'
  | 'animals'
  | 'art'
  | 'books'
  | 'history'
  | 'science'
  | 'sports';

export const TRIVIA_CATEGORY_SLUGS: readonly TriviaCategorySlug[] = [
  'music-60s',
  'music-70s',
  'geography',
  'classic-films',
  'tv-classics',
  'around-the-house',
  'animals',
  'art',
  'books',
  'history',
  'science',
  'sports',
] as const;

export function isTriviaCategorySlug(v: unknown): v is TriviaCategorySlug {
  return (
    typeof v === 'string' &&
    (TRIVIA_CATEGORY_SLUGS as readonly string[]).includes(v)
  );
}
